import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { EnvironmentService } from '@core/feature';
import { WindowRef } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class GifteryGuard implements CanActivate {
  script: HTMLScriptElement;

  constructor(
    private windowRef: WindowRef,
    private environmentService: EnvironmentService,
  ) {}

  canActivate(): boolean {
    if (!this.environmentService.isPlatformServer && !this.script) {
      this.loadGifteryScript();
    }

    return true;
  }

  private loadGifteryScript(): void {
    const script = this.windowRef.document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.src = 'https://launcher.giftery.cards/js/index.js';
    script.onerror = (): void => {
      console.error('Failed to load Giftery script');
    };
    this.script = this.windowRef.document.head.appendChild(script);
  }
}
